var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          staticClass: "mb-3 mb-xs mr-xs",
          attrs: { type: "button", variant: "outline-info" }
        },
        [
          _c(
            "label",
            {
              staticStyle: { cursor: "pointer" },
              attrs: { for: "fileuploadexcel" }
            },
            [_vm._v("\n                Upload users excel file\n            ")]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form-group row" }, [
        _c("div", { staticClass: "col-md-5" }, [
          _c("input", {
            staticClass: "display-none",
            staticStyle: { display: "none" },
            attrs: {
              accept:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
              id: "fileuploadexcel",
              type: "file",
              name: "file"
            },
            on: { change: _vm.onChangeInputImage }
          })
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group mt-4" },
        [
          _c("label", { attrs: { for: "notificationUsers" } }, [
            _vm._v("Select users")
          ]),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "w-100",
            attrs: {
              clearable: false,
              id: "notificationUsers",
              options: _vm.availableUsers
            },
            on: { input: _vm.addUser }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Widget",
        { attrs: { title: "Users in group" } },
        [
          _c("v-client-table", {
            attrs: {
              data: _vm.selectedUsers,
              columns: _vm.columnsDatatable,
              options: _vm.optionsDatatable
            },
            scopedSlots: _vm._u([
              {
                key: "Last logged in",
                fn: function(props) {
                  return _c("div", {}, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.formatDate(props.row.lastLoggedIn)) +
                        "\n                "
                    )
                  ])
                }
              },
              {
                key: "roles",
                fn: function(props) {
                  return _c(
                    "div",
                    {},
                    _vm._l(props.row.userAuthorities, function(authority, i) {
                      return _c(
                        "span",
                        { key: i, staticClass: "flex inline" },
                        [
                          _c(
                            "b-badge",
                            {
                              staticClass: "mr-1",
                              attrs: { variant: "info", pill: "" }
                            },
                            [_vm._v(_vm._s(authority.role))]
                          )
                        ],
                        1
                      )
                    }),
                    0
                  )
                }
              },
              {
                key: "delete",
                fn: function(props) {
                  return _c("div", {}, [
                    _c("span", { staticClass: "mx-auto" }, [
                      _c("span", {
                        staticClass:
                          "glyphicon glyphicon-trash icon-button p-1",
                        on: {
                          click: function($event) {
                            return _vm.removeUser(props.row)
                          }
                        }
                      })
                    ])
                  ])
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }